export const AUTH_LOGIN: string = 'auth/login';
export const AUTH_LOGOUT: string = 'auth/logout';
export const AUTH_OTP: string = 'auth/otp';
export const AUTH_REMOVE_OTP: string = 'auth/remove/otp';
